// Pregunta 3: ¿Necesitas vender una vivienda para poder comprar esta?

import React from 'react';
import { useTranslation } from 'react-i18next';
import { PROPERTY_TO_SELL_OPTIONS } from '../../../config/buyerProfileOptions';

export const PropertyToSellQuestion = ({ value, onChange, error }) => {
  const { t } = useTranslation();
  return (
    <div className="space-y-3">
      <label className="block text-sm font-semibold text-white">
        {t('questions.sell.question')} <span className="text-red-400">*</span>
      </label>

      <div className="space-y-2">
        {PROPERTY_TO_SELL_OPTIONS.map((option) => (
          <label
            key={option.value}
            className={`flex items-center gap-3 p-3 rounded-lg border cursor-pointer transition-all ${
              value === option.value
                ? 'bg-amber-500/10 border-amber-500 text-white'
                : 'bg-slate-800/50 border-slate-700 text-slate-300 hover:border-slate-600'
            }`}
          >
            <input
              type="radio"
              name="property_to_sell"
              value={option.value}
              checked={value === option.value}
              onChange={(e) => onChange(e.target.value)}
              className="w-4 h-4 text-amber-500 focus:ring-amber-500"
            />
            <span className="text-sm">{t(option.labelKey)}</span>
          </label>
        ))}
      </div>

      {error && (
        <p className="text-xs text-red-400 mt-1">{error}</p>
      )}
    </div>
  );
};

export default PropertyToSellQuestion;
